import BaseMona from '../../../scripts/modules/mona/mona-base'

import type {MousePosition} from '../mouse-position'

export default class MainMona extends BaseMona {
  constructor() {
    super(null)
    this.monaHeadGroup.rotation.order = 'YXZ'
  }

  updateMouseInteraction({current}: MousePosition, cameraFacingRotationY: number) {
    this.monaHeadGroup.rotation.y = cameraFacingRotationY + current.x * 1.5
    this.monaHeadGroup.rotation.x = -current.y * 0.4
  }
}
